import React from 'react';
import { View, TouchableOpacity, Clipboard, StyleSheet } from 'react-native';

import Modal from './shared/Modal';
import Text from './shared/Text';
import Image from './shared/Image';
import appStore from '../stores/app';
import { t } from '../utils/appUtils';
import {
  PADDING,
  PADDING1,
  pOrT,
  MARGIN_10,
  MARGIN_5,
  GOLDEN100,
  GOLDEN200,
  SECONDARY_COLOR,
} from './styleConstants';
import { DONATIONS } from '../lib/config';

type Props = { onHide: () => void };

const CRYPTO_COLORS: Record<string, string> = {
  Bitcoin: '#603a0b',
  Ethereum: '#111c47',
  Solana: '#2d134c',
};

const styles = StyleSheet.create({
  container: {
    marginTop: 20,
    padding: pOrT(30, PADDING * 2),
    flex: 1,
  },
  card: {
    borderWidth: 1,
    borderColor: GOLDEN100,
    borderRadius: 6,
    marginBottom: pOrT(8, 12),
    overflow: 'hidden',
  },
  cardHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: pOrT(6, 8),
    paddingHorizontal: pOrT(10, 14),
  },
  colorDot: {
    width: pOrT(10, 12),
    height: pOrT(10, 12),
    borderRadius: pOrT(5, 6),
    marginRight: pOrT(8, 10),
  },
  name: {
    fontSize: pOrT(13, 16),
    flex: 1,
  },
  copyLabel: {
    fontSize: pOrT(9, 11),
    opacity: 0.8,
  },
  addressBar: {
    backgroundColor: 'rgba(0,0,0,0.15)',
    paddingVertical: pOrT(5, 7),
    paddingHorizontal: pOrT(10, 14),
  },
  address: {
    fontSize: pOrT(8, 10),
    letterSpacing: 0.3,
  },
  hint: {
    marginTop: MARGIN_10,
    fontSize: pOrT(9, 11),
    opacity: 0.6,
    textAlign: 'center',
  },
});

export default function DonationModal({ onHide }: Props) {
  const onCopy = (address: string) => {
    Clipboard.setString(address);
    appStore.showMessage({ type: 'success', text: t('donation.copied') });
  };

  return (
    <Modal
      size={{ width: pOrT(500, 600), height: pOrT(300, 380) }}
      title={t('donation.title')}
      onHide={onHide}
    >
      <View style={styles.container}>
        {DONATIONS.map((item: any) => (
          <TouchableOpacity
            key={item.name}
            onPress={() => onCopy(item.address)}
            activeOpacity={0.7}
            style={styles.card}
          >
            <View style={styles.cardHeader}>
              <View
                style={[
                  styles.colorDot,
                  { backgroundColor: CRYPTO_COLORS[item.name] || GOLDEN100 },
                ]}
              />
              <Text bold style={styles.name}>
                {item.name}
              </Text>
              <Text style={styles.copyLabel}>{t('donation.copy')}</Text>
            </View>
            <View style={styles.addressBar}>
              <Text style={styles.address} {...({ numberOfLines: 1 } as any)}>
                {item.address}
              </Text>
            </View>
          </TouchableOpacity>
        ))}
        <Text style={styles.hint}>{t('donation.hint')}</Text>
      </View>
    </Modal>
  );
}
